import { render, staticRenderFns } from "./SchedulePickup.vue?vue&type=template&id=4108516c"
import script from "./SchedulePickup.vue?vue&type=script&lang=ts"
export * from "./SchedulePickup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports